import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";
import { UiInteraction } from "@obg/ngx.core";
import { ListOrientation, MenuItem } from "@obg/ngx.core.content";

@Component({
	selector: "obg-menu-item-list",
	templateUrl: "./menu-item-list.component.html",
	styleUrls: ["./menu-item-list.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class MenuItemListComponent {
	/**
	 * A string to be shown as a title for the section
	 */
	@Input() titleText?: string;
	/**
	 * A list of items
	 */
	@Input() items: MenuItem[] = [];
	/**
	 * The orientation of the list
	 */
	@Input() orientation?: ListOrientation;
	/**
	 * ui interaction event data
	 */
	@Input() uiInteraction: UiInteraction | undefined;

	@HostBinding("class.obg-menu-item-list") hostCssClass = true;

	get isOrientationVertical(): boolean {
		return this.orientation === ListOrientation.Vertical;
	}

	trackByItem(_index: number, item: MenuItem) {
		return item.key;
	}
}
